(() => {
  const JANUARY_SELLING_PLAN_ID = 690559975749;
  const EXTRA_DELIVERY_VARIANT_ID = 59356640411973;
  const SEED_TAG = "januarilada-frö";

  const DELIVERY_CHOICE = {
    JANUARY_BOX: "Januarilåda",
    SEND_NOW: "Skicka nu",
    SPLIT: "Delleverans",
    PRODUCTS_NOW: "Prylar nu – fröer januari",
    PRODUCTS_AND_STOCK_NOW: "Prylar nu – lagerfröer nu",
    PRODUCTS_AND_STOCK_JANUARY: "Prylar nu – lagerfröer januari",
  };

  function getPurchaseOrderTag(choice) {
    switch (choice) {
      case DELIVERY_CHOICE.JANUARY_BOX:
        return "KÖPORDNING-JANUARILÅDA-2027";
      case DELIVERY_CHOICE.SEND_NOW:
        return "KÖPORDNING-SKICKA-NU-2027";
      case DELIVERY_CHOICE.SPLIT:
        return "KÖPORDNING-DELLEVERANS-2027";
      case DELIVERY_CHOICE.PRODUCTS_NOW:
      case DELIVERY_CHOICE.PRODUCTS_AND_STOCK_JANUARY:
        return "KÖPORDNING-PRYLAR-NU-FRÖER-JANUARI-2027";
      case DELIVERY_CHOICE.PRODUCTS_AND_STOCK_NOW:
        return "KÖPORDNING-PRYLAR-NU-LAGERFRÖER-2027";
      default:
        return "";
    }
  }

  const productCache = new Map();
  let isUpdating = false;
  let cartChangeTimer;

  function getRoot() {
    return window.Shopify?.routes?.root || "/";
  }

  async function getCart() {
    const response = await fetch(`${getRoot()}cart.js`, {
      headers: { Accept: "application/json" },
    });

    if (!response.ok) {
      throw new Error("Kunde inte läsa varukorgen.");
    }

    return response.json();
  }

  async function getProductTags(handle) {
    if (productCache.has(handle)) {
      return productCache.get(handle);
    }

    const response = await fetch(
      `${getRoot()}products/${encodeURIComponent(handle)}.js`,
      { headers: { Accept: "application/json" } }
    );

    if (!response.ok) {
      throw new Error(`Kunde inte läsa produkten ${handle}.`);
    }

    const product = await response.json();
    const tags = Array.isArray(product.tags) ? product.tags : [];
    productCache.set(handle, tags);
    return tags;
  }

  function isJanuaryPreorder(item) {
    return (
      Number(item.selling_plan_allocation?.selling_plan?.id) ===
      JANUARY_SELLING_PLAN_ID
    );
  }

  function isExtraDelivery(item) {
    return Number(item.variant_id) === EXTRA_DELIVERY_VARIANT_ID;
  }

  async function changeLineQuantity(lineKey, quantity) {
    const response = await fetch(`${getRoot()}cart/change.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        id: lineKey,
        quantity,
      }),
    });

    if (!response.ok) {
      throw new Error("Varukorgen kunde inte uppdateras.");
    }

    return response.json();
  }

  async function removeLegacyExtraDelivery(cart) {
    const feeItem = cart.items.find(isExtraDelivery);

    if (!feeItem) {
      return false;
    }

    await changeLineQuantity(feeItem.key, 0);
    return true;
  }

  async function saveDeliveryChoice(choice) {
    const response = await fetch(`${getRoot()}cart/update.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        attributes: {
          Leveransval: choice || "",
          Köpordning: getPurchaseOrderTag(choice),
        },
      }),
    });

    if (!response.ok) {
      throw new Error("Leveransvalet kunde inte sparas.");
    }

    return response.json();
  }

  function setCheckoutDisabled(disabled) {
    const checkoutButton = document.querySelector("#checkout");

    if (!checkoutButton) {
      return;
    }

    if (disabled) {
      checkoutButton.disabled = true;
      checkoutButton.dataset.januariladaDisabled = "true";
      return;
    }

    if (checkoutButton.dataset.januariladaDisabled === "true") {
      checkoutButton.disabled = false;
      delete checkoutButton.dataset.januariladaDisabled;
    }
  }

  function setExpressCheckoutHidden(hidden) {
    const expressCheckout = document.querySelector(
      ".additional-checkout-buttons"
    );

    if (!expressCheckout) {
      return;
    }

    if (hidden) {
      expressCheckout.style.display = "none";
      expressCheckout.dataset.januariladaHidden = "true";
      return;
    }

    if (expressCheckout.dataset.januariladaHidden === "true") {
      expressCheckout.style.removeProperty("display");
      delete expressCheckout.dataset.januariladaHidden;
    }
  }

  async function classifyCart(cart) {
    const relevantItems = cart.items.filter((item) => !isExtraDelivery(item));

    const itemsWithTags = await Promise.all(
      relevantItems.map(async (item) => ({
        ...item,
        productTags: await getProductTags(item.handle),
      }))
    );

    const hasJanuaryPreorder = itemsWithTags.some(isJanuaryPreorder);

    const hasStockSeed = itemsWithTags.some(
      (item) =>
        !isJanuaryPreorder(item) && item.productTags.includes(SEED_TAG)
    );

    const hasOtherProducts = itemsWithTags.some(
      (item) =>
        !isJanuaryPreorder(item) && !item.productTags.includes(SEED_TAG)
    );

    return {
      hasJanuaryPreorder,
      hasStockSeed,
      hasOtherProducts,
    };
  }

  function renderInformationBox(title, text) {
    return `
      <div class="januarilada-box">
        <span class="januarilada-box__title">${title}</span>
        <p class="januarilada-box__text">${text}</p>
      </div>
    `;
  }

  function renderDeliveryChoices(currentChoice, choices) {
    const choiceMarkup = choices
      .map(
        (choice) =>
          `<label class="januarilada-option"><input type="radio" name="januarilada-leveransval" value="${choice.value}" ${currentChoice === choice.value ? "checked" : ""}><span><span class="januarilada-option__title">${choice.title}</span><span class="januarilada-option__description">${choice.description}</span></span></label>`
      )
      .join("");

    return `
      <div class="januarilada-box">
        <fieldset class="januarilada-box__fieldset">
          <legend class="januarilada-box__legend">
            När vill du få dina fröer?
          </legend>
          <p class="januarilada-box__text">
            Samla dina frököp till en gemensam januarileverans. <a href="https://snittblomsfolk.com/pages/januariladan-sa-fungerar-samlad-froleverans" target="_blank" rel="noopener" style="color: #4b362a; text-decoration-color: #4b362a;">Läs mer om Januarilådan</a>
          </p>
          ${choiceMarkup}
        </fieldset>
      </div>
    `;
  }

  async function renderJanuaryBox() {
    if (isUpdating) {
      return;
    }

    isUpdating = true;

    try {
      const container = document.querySelector(
        "#januarilada-delivery-options"
      );

      if (!container) {
        console.warn("Januarilådans behållare hittades inte.");
        return;
      }

      const cart = await getCart();

      if (await removeLegacyExtraDelivery(cart)) {
        window.location.reload();
        return;
      }

      const classification = await classifyCart(cart);
      const { hasJanuaryPreorder, hasStockSeed, hasOtherProducts } =
        classification;
      const hasSeedItems = hasJanuaryPreorder || hasStockSeed;

      let currentChoice = cart.attributes?.Leveransval || "";

      if (!hasSeedItems) {
        container.hidden = true;
        container.innerHTML = "";
        setCheckoutDisabled(false);
        setExpressCheckoutHidden(false);

        if (currentChoice || cart.attributes?.Köpordning) {
          await saveDeliveryChoice("");
        }

        return;
      }

      if (hasOtherProducts && hasJanuaryPreorder) {
        currentChoice = DELIVERY_CHOICE.PRODUCTS_NOW;

        if (cart.attributes?.Leveransval !== currentChoice) {
          await saveDeliveryChoice(currentChoice);
        }

        container.innerHTML = renderInformationBox(
          "Din Januarilåda är öppen",
          "Din order delas upp i två leveranser. Prylar och eventuella lagerfröer skickas nu. Januariförköpen skickas från 5 januari 2027, i lagom tid för sådd. Du behöver inte göra något mer. <a href=\"https://snittblomsfolk.com/pages/januariladan-sa-fungerar-samlad-froleverans\" target=\"_blank\" rel=\"noopener\" style=\"color: #4b362a; text-decoration-color: #4b362a;\">Läs mer om Januarilådan</a>"
        );
        container.hidden = false;
      } else if (hasOtherProducts && hasStockSeed) {
        const choices = [
          {
            value: DELIVERY_CHOICE.PRODUCTS_AND_STOCK_NOW,
            title: "Skicka lagerfröerna nu",
            description:
              "Prylar och lagerfröer skickas direkt.",
          },
          {
            value: DELIVERY_CHOICE.PRODUCTS_AND_STOCK_JANUARY,
            title: "Lägg lagerfröerna i Januarilådan",
            description:
              "Prylarna skickas direkt och lagerfröerna hålls till januari. Ingen separat januarifrakt tas ut.",
          },
        ];

        if (!choices.some((choice) => choice.value === currentChoice)) {
          currentChoice = DELIVERY_CHOICE.PRODUCTS_AND_STOCK_NOW;
          await saveDeliveryChoice(currentChoice);
        }

        container.innerHTML = renderDeliveryChoices(currentChoice, choices);
        container.hidden = false;
      } else if (hasStockSeed) {
        const choices = hasJanuaryPreorder
          ? [
              {
                value: DELIVERY_CHOICE.JANUARY_BOX,
                title: "Samla fröerna i Januarilådan – rekommenderas",
                description:
                  "Fröerna skickas i januari, i lagom tid för sådd. Du kan fylla på fram till 5 januari utan ny frakt.",
              },
              {
                value: DELIVERY_CHOICE.SPLIT,
                title: "Jag behöver lagerfröerna tidigare",
                description:
                  "Behöver du lagerfröerna nu? Då skickas de direkt och förköpsfröerna i januari. Det blir två leveranser.",
              },
            ]
          : [
              {
                value: DELIVERY_CHOICE.JANUARY_BOX,
                title: "Samla fröerna i Januarilådan – rekommenderas",
                description:
                  "Fröerna skickas i januari, i lagom tid för sådd. Du kan fylla på fram till 5 januari utan ny frakt.",
              },
              {
                value: DELIVERY_CHOICE.SEND_NOW,
                title: "Jag behöver lagerfröerna tidigare",
                description:
                  "Behöver du lagerfröerna nu? Då skickas de direkt med vanlig fröfrakt.",
              },
            ];

        if (!choices.some((choice) => choice.value === currentChoice)) {
          currentChoice = DELIVERY_CHOICE.JANUARY_BOX;
          await saveDeliveryChoice(currentChoice);
        }

        container.innerHTML = renderDeliveryChoices(currentChoice, choices);
        container.hidden = false;
      } else {
        currentChoice = DELIVERY_CHOICE.JANUARY_BOX;

        if (cart.attributes?.Leveransval !== currentChoice) {
          await saveDeliveryChoice(currentChoice);
        }

        container.innerHTML = renderInformationBox(
          "Din Januarilåda är öppen",
          "Du kan fylla på med fler fröer fram till leveransen och få dem samlade i januari. Leveranser påbörjas den 5 januari 2027."
        );
        container.hidden = false;
      }

      setExpressCheckoutHidden(
        hasJanuaryPreorder ||
          currentChoice === DELIVERY_CHOICE.JANUARY_BOX ||
          currentChoice === DELIVERY_CHOICE.PRODUCTS_AND_STOCK_JANUARY
      );
      setCheckoutDisabled(false);

      console.log("Januarilådan:", {
        hasJanuaryPreorder,
        hasStockSeed,
        hasOtherProducts,
        deliveryChoice: currentChoice,
        purchaseOrderTag: getPurchaseOrderTag(currentChoice),
      });
    } catch (error) {
      console.error("Januarilådan kunde inte laddas:", error);
      setCheckoutDisabled(true);
    } finally {
      isUpdating = false;
    }
  }

  function scheduleJanuaryBoxUpdate() {
    window.clearTimeout(cartChangeTimer);

    cartChangeTimer = window.setTimeout(async () => {
      try {
        await renderJanuaryBox();
      } catch (error) {
        console.error(
          "Januarilådan kunde inte uppdateras efter varukorgsändring:",
          error
        );
      }
    }, 700);
  }

  function observeCartChanges() {
    const cartItems = document.querySelector("cart-items, #main-cart-items");

    if (!cartItems) {
      return;
    }

    const cartObserver = new MutationObserver(() => {
      scheduleJanuaryBoxUpdate();
    });

    cartObserver.observe(cartItems, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  document.addEventListener("change", async (event) => {
    if (event.target.name !== "januarilada-leveransval") {
      return;
    }

    try {
      setCheckoutDisabled(true);
      await saveDeliveryChoice(event.target.value);
      await renderJanuaryBox();
    } catch (error) {
      console.error("Kunde inte spara leveransvalet:", error);
      setCheckoutDisabled(true);
    }
  });

  document.addEventListener("change", (event) => {
    if (
      event.target.matches(
        'input[name="updates[]"], .quantity__input'
      )
    ) {
      scheduleJanuaryBoxUpdate();
    }
  });

  document.addEventListener("click", (event) => {
    if (
      event.target.closest("cart-remove-button, .cart-remove-button")
    ) {
      scheduleJanuaryBoxUpdate();
    }
  });

  document.addEventListener("DOMContentLoaded", async () => {
    observeCartChanges();
    await renderJanuaryBox();
  });

  document.addEventListener("cart:updated", async () => {
    await renderJanuaryBox();
  });
})();